import { passwordRecoveryFeature } from './password-recovery.reducer';

export const {
  selectUsername,
  selectActivationToken,
  selectTokenType,
  selectNextStep,
  selectLoginMethod,
  selectExpiresIn,
  selectExpiresAt,
  selectMessage,
  selectResultStatus,
  selectCanGoToStep,
  selectLoading,
  selectError,
  selectPasswordRecoveryState,
} = passwordRecoveryFeature;
